import { render, staticRenderFns } from "./ConstructionDetailForm.vue?vue&type=template&id=5c207bc9&scoped=true"
import script from "./ConstructionDetailForm.vue?vue&type=script&lang=js"
export * from "./ConstructionDetailForm.vue?vue&type=script&lang=js"
import style0 from "./ConstructionDetailForm.vue?vue&type=style&index=0&id=5c207bc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c207bc9",
  null
  
)

export default component.exports